<template>
    <div id="assign-loan-responsibles">
        <vs-list>
            <vs-list-item :title="!isFromCreditRisk ? 'Responsable de originación' : 'Analista de riesgo:'">
                <vs-select
                    id="select-loan-analyst"
                    placeholder="Selecciona un opción" 
                    v-model="selectedAnalyst" 
                    @change="onAnalystChange"
                    :options="collections.analystsOptions"
                    :disabled="isSaving">
                    <vs-select-item
                        :key="index"
                        :value="item.id"
                        :text="item.select_name"
                        v-for="( item, index ) in collections.analystsOptions"
                        class="w-full"
                        />
                </vs-select>
            </vs-list-item>
          </vs-list>
    </div>
</template>

<script>
export default {
    data: () => ({
        selectedAnalyst: null,
        originalAnalyst: null,
        ready: false, 
        isSaving: false,
        collections: {
            analystsOptions: []
        }
    }),
    props: {
        type: {
            type: String,
            required: true
        },
        loan: {
            type: Object,
            required: true
        }
    },
    async mounted() {
        await this.getCollections();
        this.setAnalyst();                         // setea el valor inicial según loan
        this.originalAnalyst = this.selectedAnalyst; // guarda el “baseline”
    },
    created() {
        this.isSaving = false;
        this.$nextTick(() => { this.ready = true; }); // ya se puede escuchar cambios
    },
    computed: {
        isFromCreditRisk() {
            return this.type == 'credit_risk';
        },
        hasAssignedAnalyst() {
            return this.isFromCreditRisk
                ? this.loan.credit_risk_responsible_id !== null
                : this.loan.origination_responsible_id !== null;

        },
        
    },
    // watch: {
    //     selectedAnalyst(newVal) {
    //         this.setAnalystToLoan();
    //     }
    // },
    methods: {
        async getCollections(){
            try {
                let res = await this.publicApiGet(`/api/v1/forms/getUsersByRole/${this.type}`);
                let colls = res.data;
                this.collections.analystsOptions = colls;
            }
            catch (e) {
            }
        },
        setAnalyst() {
            this.selectedAnalyst = this.isFromCreditRisk ? this.loan.credit_risk_responsible_id : this.loan.origination_responsible_id;
        },
        async onAnalystChange(newVal) {
            // 1) Ignora el cambio si seguimos inicializando
            if (!this.ready) return;

            // 2) Normaliza tipos por si vienen como string/number distintos
            const oldId = this.originalAnalyst == null ? null : this.originalAnalyst;
            const newId = newVal == null ? null : newVal;

            // 3) Si no cambió realmente, no pegues al API
            if (oldId === newId) return;

            await this.setAnalystToLoan(newVal);

            // 4) Si guardó bien, actualiza el baseline
            this.originalAnalyst = newVal;
        },
        async setAnalystToLoan(val) {
            try {
                this.isSaving = true;
                this.showLoading(true, "Asignando responsable...");
                const res = await axios.post(`/api/v2/projects/responsible/assign`, {
                    loan_id: this.loan.id,
                    responsible_id: val,
                    type: this.type
                });

                this.saveSuccessNotif(null, "Responsable asignado correctamente");

            } catch (error) {
                this.failedOperationNotif(null, "No se pudo asignar el responsable");
                console.error(error);
            }
            finally {
                this.showLoading(false);
                this.isSaving = false;
            }
        }
    }
}
</script>

<style>
#select-loan-analyst { min-width: 17.5rem; }

</style>